import React, { useEffect } from "react"
import Axios from "axios"
import { useImmerReducer } from "use-immer"

// My Components
import { Hero, Button, Icon, MovieCard, Skeleton, Page } from "../../components"
import { Section } from "../../containers"
import { API_URL, API_KEY, IMAGE_BASE_URL, POSTER_SIZE, BACKDROP_SIZE } from "../../helpers/config"

function Home() {
  const initialState = {
    movies: [
      {
        id: "",
        overview: "",
        release_date: "",
        adult: "",
        backdrop_path: "",
        vote_count: "",
        genre_ids: [],
        vote_average: "",
        original_language: "",
        original_title: "",
        poster_path: "",
        title: "",
        video: "",
        popularity: "",
        media_type: "",
      },
    ],
    tv: [
      {
        genre_ids: [],
        original_name: "",
        origin_country: [],
        poster_path: "",
        vote_average: "",
        id: "",
        overview: "",
        vote_count: 1064,
        name: "",
        original_language: "",
        backdrop_path: "",
        first_air_date: "",
        popularity: "",
        media_type: "",
      },
    ],
    top: [
      {
        id: "",
        overview: "",
        release_date: "",
        adult: "",
        backdrop_path: "",
        vote_count: "",
        genre_ids: [],
        vote_average: "",
        original_language: "",
        original_title: "",
        poster_path: "",
        title: "",
        video: "",
        popularity: "",
        media_type: "",
      },
    ],

    isMovieFetching: "",
    isTvFetching: "",
  }

  function ourReducer(draft, action) {
    switch (action.type) {
      case "loadMovies":
        draft.movies = action.data
        return
      case "fetchingRequestStart":
        draft.isMovieFetching = action.value
        return
      case "loadTvShows":
        draft.tv = action.data
        return
      case "fetchiTvShowsStart":
        draft.isTvFetching = action.value
        return
      case "loadTopMovies":
        draft.top = action.data
        return
      default:
        console.log("our")
    }
  }

  const [state, dispatch] = useImmerReducer(ourReducer, initialState)

  const fetchMovie = async function (ourRuqest) {
    try {
      let response = await Axios.get(`${API_URL}trending/movie/week?api_key=${API_KEY}`, {
        cancelToken: ourRuqest.token,
      })
      if (response.data) {
        dispatch({ type: "loadMovies", data: response.data.results })
      }
    } catch (error) {
      console.log(error)
    }
  }

  const fetchTvShow = async function (ourRuqest) {
    try {
      let response = await Axios.get(`${API_URL}trending/tv/day?api_key=${API_KEY}`, {
        cancelToken: ourRuqest.token,
      })
      if (response.data) {
        dispatch({ type: "loadTvShows", data: response.data.results })
      }
    } catch (error) {
      console.log(error)
    }
  }
  const fetchTopMovie = async function (ourRuqest) {
    try {
      let response = await Axios.get(`${API_URL}movie/top_rated?api_key=${API_KEY}`, {
        cancelToken: ourRuqest.token,
      })
      if (response.data) {
        dispatch({ type: "loadTopMovies", data: response.data.results })
      }
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    const ourRuqest = Axios.CancelToken.source()
    fetchMovie(ourReducer)
    fetchTvShow(ourReducer)
    fetchTopMovie(ourRuqest)
    return () => {
      ourRuqest.cancel()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const skelletonCard = function () {
    return (
      <>
        <Skeleton.MovieCard />
        <Skeleton.MovieCard />
        <Skeleton.MovieCard />
        <Skeleton.MovieCard />
        <Skeleton.MovieCard />
        <Skeleton.MovieCard />
        <Skeleton.MovieCard />
        <Skeleton.MovieCard />
      </>
    )
  }

  return (
    <Page title="Home">
      <Hero
        path={
          state.movies[0].backdrop_path
            ? `${IMAGE_BASE_URL}${BACKDROP_SIZE}${state.movies[0].backdrop_path}`
            : ""
        }
      >
        <Hero.Content>
          <Hero.Rating rate={state.movies[0].vote_average} />
          <Hero.Title year="2021">{state.movies[0].title}</Hero.Title>
          <Hero.Date>{state.movies[0].release_date}</Hero.Date>
          <Hero.Overview>{state.movies[0].overview}</Hero.Overview>
          <Button.Primary to={`/movie/${state.movies[0].id}`}>
            View Full Cast And Crew
          </Button.Primary>
        </Hero.Content>
      </Hero>

      <Section>
        <Section.Wrapper>
          <Section.Head>
            <Section.Left>
              <Section.Title>Tranding Movies</Section.Title>
              <Icon name="ph-film-strip" size="16" color="#000" />
            </Section.Left>
            <Section.Right>
              <Section.ViewAll to="/popular-movies">View All</Section.ViewAll>
            </Section.Right>
          </Section.Head>
          <Section.Body>
            <Section.ScrollContainer>
              {state.movies[0].title === "" && skelletonCard()}
              {state.movies[0].title !== "" &&
                state.movies.map((movie) => {
                  return (
                    <MovieCard key={movie.id} to={`movie/${movie.id}`}>
                      <MovieCard.Thumb rate={movie.vote_average}>
                        <MovieCard.Rating rate={movie.vote_average} />
                        <MovieCard.Image
                          path={`${IMAGE_BASE_URL}${POSTER_SIZE}${movie.poster_path}`}
                        />
                      </MovieCard.Thumb>
                      <MovieCard.Info>
                        <MovieCard.Title>{movie.title}</MovieCard.Title>
                        <MovieCard.Date>{movie.release_date}</MovieCard.Date>
                      </MovieCard.Info>
                    </MovieCard>
                  )
                })}
            </Section.ScrollContainer>
          </Section.Body>
        </Section.Wrapper>
      </Section>

      <Section>
        <Section.Wrapper>
          <Section.Head>
            <Section.Left>
              <Section.Title>Tranding Tv Shows</Section.Title>
              <Icon name="ph-television-simple" size="16" color="#000" />
            </Section.Left>
            <Section.Right>
              <Section.ViewAll to="/tv-shows">View All</Section.ViewAll>
            </Section.Right>
          </Section.Head>
          <Section.Body>
            <Section.ScrollContainer>
              {state.tv[0].name === "" && skelletonCard()}
              {state.tv[0].name !== "" &&
                state.tv.map((tv) => {
                  return (
                    <MovieCard key={tv.id} to={`tv/${tv.id}`}>
                      <MovieCard.Thumb rate={tv.vote_average}>
                        <MovieCard.Rating rate={tv.vote_average} />
                        <MovieCard.Image
                          path={`${IMAGE_BASE_URL}${POSTER_SIZE}${tv.poster_path}`}
                        />
                      </MovieCard.Thumb>
                      <MovieCard.Info>
                        <MovieCard.Title>{tv.name}</MovieCard.Title>
                        <MovieCard.Date>{tv.first_air_date}</MovieCard.Date>
                      </MovieCard.Info>
                    </MovieCard>
                  )
                })}
            </Section.ScrollContainer>
          </Section.Body>
        </Section.Wrapper>
      </Section>

      <Section>
        <Section.Wrapper>
          <Section.Head>
            <Section.Left>
              <Section.Title>Top Rated Movies</Section.Title>
              <Icon name="ph-star" size="16" color="#000" />
            </Section.Left>
            <Section.Right>
              <Section.ViewAll to="/top-rated-movies">View All</Section.ViewAll>
            </Section.Right>
          </Section.Head>
          <Section.Body>
            <Section.ScrollContainer>
              {state.top[0].title === "" && skelletonCard()}
              {state.top[0].title !== "" &&
                state.top.map((movie) => {
                  return (
                    <MovieCard key={movie.id} to={`movie/${movie.id}`}>
                      <MovieCard.Thumb rate={movie.vote_average}>
                        <MovieCard.Rating rate={movie.vote_average} />
                        <MovieCard.Image
                          path={`${IMAGE_BASE_URL}${POSTER_SIZE}${movie.poster_path}`}
                        />
                      </MovieCard.Thumb>
                      <MovieCard.Info>
                        <MovieCard.Title>{movie.title}</MovieCard.Title>
                        <MovieCard.Date>{movie.release_date}</MovieCard.Date>
                      </MovieCard.Info>
                    </MovieCard>
                  )
                })}
            </Section.ScrollContainer>
          </Section.Body>
        </Section.Wrapper>
      </Section>

      {/* <Carousel>
        <Carousel.Inner>
          <Carousel.Thumbnail path="https://www.themoviedb.org/t/p/${POSTER_SIZE}/2CAL2433ZeIihfX1Hb2139CX0pW.jpg" />
          <Carousel.Content>
            <Carousel.Title>Dilwale Dulhania Le Jayenge</Carousel.Title>
            <Carousel.Subtitle>10/20/1995 (IN)</Carousel.Subtitle>
            <Carousel.Subtitle>Comedy, Drama, Romance</Carousel.Subtitle>
            <Carousel.SecondHeadline>Overview</Carousel.SecondHeadline>
            <Carousel.Overview>Raj is a rich, carefree, happy-go-lucky second generation NRI. Simran is the daughter of Chaudhary Baldev Singh, who in spite of being an NRI is very strict about adherence to Indian values. Simran has left for India to be married to her childhood fiancé. Raj leaves for India with a mission at his hands, to claim his lady love under the noses of her whole family. Thus begins a saga.</Carousel.Overview>
            <Button.Primary to="movie/456132">Full Cast And Crew</Button.Primary>
          </Carousel.Content>
        </Carousel.Inner>
      </Carousel> */}
    </Page>
  )
}

export default Home
